(function () {
  'use strict';

  var STORAGE_KEY = 'fjor_quiz_v2';
  var VARIANT_KEY = 'fjor_quiz_variant_v1';
  var INTRO_VARIANT_KEY = 'fjor_quiz_intro_variant_v1';
  var SCORED_KEYS = ['quiz_energy', 'quiz_morning', 'quiz_libido', 'quiz_motivation', 'quiz_sleep', 'quiz_training', 'quiz_stress'];
  var MAX_RAW = SCORED_KEYS.length * 4;

  // QUIZ-VARIATIONS-10 intro copy map. Only swaps intro step (data-fjq-id="intro").
  // Scored questions, results layer, gates, and CTAs are untouched.
  // Activate via ?quiz_variant=v0X (case-insensitive). Unknown values fall through to v01 control.
  var QUIZ_INTRO_VARIANTS = {
    v01: {},
    v02: {
      h1: 'What is your biggest masculine health concern right now?',
      sub: 'Pick one. We will build your protocol around it in under 90 seconds.'
    },
    v03: {
      eyebrow: 'Protocol assessment',
      h1: 'See if your daily stack matches your symptoms.',
      sub: 'This is a screening-style check, not a product quiz. No bloodwork required.'
    },
    v04: {
      h1: 'Do you hit a wall by 2-3pm most days?',
      sub: 'Answer 8 quick questions. Get a vitality score and a morning-to-night protocol.',
      painlist: [
        'Energy that vanishes by 2-3pm',
        'Coffee no longer fixes the crash',
        'Workouts that used to feel easy now drain you',
        'Slower recovery, smaller gains'
      ]
    },
    v05: {
      h1: 'Has your drive in the bedroom slipped lately?',
      sub: 'Private. 90 seconds. A tier score and what to do next.'
    },
    v06: {
      h1: 'Harder to build muscle or stay lean than a few years ago?',
      sub: '8 questions on recovery, training, and daily energy.'
    },
    v07: {
      h1: 'Considering TRT? Start with a 90-day natural fair test first.',
      sub: 'No needles. No clinic visits. A scored check and a subscribe path with a guarantee.'
    },
    v08: {},
    v09: {
      sub: 'Some men discover they are already in a strong baseline. We will tell you honestly.'
    },
    v10: {
      trust: '50% off first order · 90-day guarantee · free shipping on subscribe'
    }
  };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function slugify(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 48);
  }

  function loadAnswers() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); } catch (e) { return {}; }
  }

  function saveAnswers(data) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function applyIntroVariant(root) {
    if (!root) return null;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var raw = (params.get('quiz_variant') || '').toLowerCase();
    if (!raw || !Object.prototype.hasOwnProperty.call(QUIZ_INTRO_VARIANTS, raw)) {
      // Fallback: ad UTMs may carry the variant in utm_content=v0X.
      var utmRaw = (params.get('utm_content') || '').toLowerCase();
      if (utmRaw && Object.prototype.hasOwnProperty.call(QUIZ_INTRO_VARIANTS, utmRaw)) {
        raw = utmRaw;
      }
    }
    if (!raw || !Object.prototype.hasOwnProperty.call(QUIZ_INTRO_VARIANTS, raw)) return null;
    var spec = QUIZ_INTRO_VARIANTS[raw];
    var intro = root.querySelector('[data-fjq-id="intro"]');
    if (!intro) return raw;

    if (spec.eyebrow) {
      var eyebrowEl = intro.querySelector('[data-fjq-intro-eyebrow]') || intro.querySelector('.fjq-eyebrow--hero');
      if (eyebrowEl) eyebrowEl.textContent = spec.eyebrow;
    }
    if (spec.h1) {
      var headlineEl = intro.querySelector('[data-fjq-intro-h1]') || intro.querySelector('.fjq-headline--hero');
      if (headlineEl) headlineEl.textContent = spec.h1;
    }
    if (spec.sub) {
      var subEl = intro.querySelector('[data-fjq-intro-sub]') || intro.querySelector('.fjq-subhead');
      if (subEl) subEl.textContent = spec.sub;
    }
    if (spec.painlist && Object.prototype.toString.call(spec.painlist) === '[object Array]') {
      var painUl = intro.querySelector('[data-fjq-intro-painlist]') || intro.querySelector('.fjq-painlist');
      if (painUl) {
        painUl.innerHTML = '';
        spec.painlist.forEach(function (item) {
          var li = document.createElement('li');
          li.textContent = String(item);
          painUl.appendChild(li);
        });
      }
    }
    if (spec.trust) {
      var trustEl = intro.querySelector('[data-fjq-intro-trust]') || intro.querySelector('.fjq-trust');
      if (trustEl) trustEl.textContent = spec.trust;
    }

    root.dataset.quizVariant = raw;
    try { sessionStorage.setItem(INTRO_VARIANT_KEY, raw); } catch (e) {}
    return raw;
  }

  function resolveVariant(override) {
    if (override === 'gated' || override === 'open' || override === 'soft') return override;
    try {
      var existing = sessionStorage.getItem(VARIANT_KEY);
      if (existing === 'gated' || existing === 'open' || existing === 'soft') return existing;
    } catch (e) {}
    var r = Math.random();
    var assigned = r < 0.3333 ? 'gated' : (r < 0.6666 ? 'open' : 'soft');
    try { sessionStorage.setItem(VARIANT_KEY, assigned); } catch (e) {}
    return assigned;
  }

  function track(eventName, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, quiz: detail || {} });
    if (typeof window.fjqOnTrack === 'function') {
      try { window.fjqOnTrack(eventName, detail); } catch (e) {}
    }
  }

  function pushKlaviyo(email, payload) {
    var kl = window._learnq || window.klaviyo;
    if (!kl) return false;
    try {
      var identify = Object.assign({ $email: email }, payload);
      if (typeof kl.push === 'function') {
        kl.push(['identify', identify]);
        kl.push(['track', 'Quiz Completed', payload]);
      } else if (typeof kl.identify === 'function') {
        kl.identify(Object.assign({ email: email }, payload));
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function computeScore(answers, scoreMap) {
    var raw = 0;
    var lowestKey = null;
    var lowestScore = Infinity;
    SCORED_KEYS.forEach(function (key) {
      var s = typeof scoreMap[key] === 'number' ? scoreMap[key] : 4;
      raw += s;
      if (answers[key] && s < lowestScore) {
        lowestScore = s;
        lowestKey = key;
      }
    });
    var normalized = Math.round((raw / MAX_RAW) * 100);
    return { raw: raw, score: normalized, topSymptomKey: lowestKey };
  }

  function tierFromScore(score) {
    if (score >= 80) return 'a';
    if (score >= 60) return 'b';
    if (score >= 40) return 'c';
    return 'd';
  }

  function readTierCopyFromSettings(root) {
    return {
      a: { label: root.dataset.tierALabel || 'Strong baseline', headline: root.dataset.tierAHeadline || '', message: root.dataset.tierAMessage || '' },
      b: { label: root.dataset.tierBLabel || 'Showing wear', headline: root.dataset.tierBHeadline || '', message: root.dataset.tierBMessage || '' },
      c: { label: root.dataset.tierCLabel || 'Significant signals', headline: root.dataset.tierCHeadline || '', message: root.dataset.tierCMessage || '' },
      d: { label: root.dataset.tierDLabel || 'High alert', headline: root.dataset.tierDHeadline || '', message: root.dataset.tierDMessage || '' }
    };
  }

  function pillarTrain(topSymptomKey, tier) {
    var body;
    if (topSymptomKey === 'quiz_training') {
      body = '3 heavy compound sessions a week beats 5 mediocre ones. Squat, deadlift, press, row. Track loads and progress them. Stop if you are overreaching.';
    } else if (topSymptomKey === 'quiz_sleep') {
      body = 'Lift heavy 3 times a week, then leave the rest of the week for walking and recovery. Do not grind on top of poor sleep.';
    } else if (tier === 'a') {
      body = 'Keep what is working. 3 to 4 strength sessions a week, progressive overload, full recovery. Do not sabotage a good baseline with junk volume.';
    } else {
      body = 'Strength train 3 to 4 times a week. Heavy compound lifts (squat, deadlift, press, row) drive the strongest hormonal response. Progressive overload over time.';
    }
    return '<strong>Train</strong>' + body;
  }

  function pillarEat(topSymptomKey, tier) {
    var body;
    if (topSymptomKey === 'quiz_libido') {
      body = 'Healthy fats (eggs, red meat, olive oil, avocado) are the raw material for testosterone. Going low-fat tanks libido fast. Cholesterol is not the enemy here.';
    } else if (topSymptomKey === 'quiz_energy') {
      body = 'Stop snacking on processed carbs. Build meals around protein and fat to flatten the afternoon crash. Real food first.';
    } else if (tier === 'd') {
      body = 'Diet is your highest-leverage lever right now. Around 1g of protein per pound bodyweight, whole-food carbs, cut seed oils. Three weeks of clean eating changes how you feel.';
    } else {
      body = 'Build meals around real protein (around 1g per pound bodyweight), eggs, red meat, fatty fish, and whole-food carbs. Cut seed oils and ultra-processed food where you can.';
    }
    return '<strong>Eat</strong>' + body;
  }

  function pillarRecover(topSymptomKey, tier) {
    var body;
    if (topSymptomKey === 'quiz_sleep') {
      body = 'Dark, cool room. Same bedtime nightly. No phone in bed. Get 10 to 20 minutes of morning sun within an hour of waking. Sleep is the foundation everything else stacks on.';
    } else if (topSymptomKey === 'quiz_stress') {
      body = 'Daily walks, ideally outdoors. Lower the cortisol load. Caffeine before noon only. Alcohol is doing more damage than you think.';
    } else if (topSymptomKey === 'quiz_motivation') {
      body = 'Sleep and sun first. Motivation usually returns when the baseline recovers, not before. Walks beat scrolling.';
    } else {
      body = 'Sleep 7 to 9 hours. Get 10 to 20 minutes of direct morning sunlight to anchor your circadian rhythm. Walk daily. Limit alcohol.';
    }
    return '<strong>Recover</strong>' + body;
  }

  function pillarStack(tier) {
    var body;
    if (tier === 'a') {
      body = 'Even at a strong baseline, a quality daily stack protects what is working. Inner Warrior is a 13-ingredient daily stack. $29.99 with subscription, 90-day guarantee.';
    } else if (tier === 'd') {
      body = 'When the gap is this wide, food and training alone are slower than you want. Inner Warrior is the 13-ingredient daily stack built for this exact profile. $29.99 with subscription, 90-day guarantee.';
    } else {
      body = 'A daily testosterone-support stack fills what food and training alone cannot reach. Inner Warrior is a 13-ingredient daily stack. $29.99 with subscription, 90-day guarantee.';
    }
    return '<strong>Stack</strong>' + body;
  }

  var GOAL_TO_LEAD = {
    energy: 'recover',
    drive: 'eat',
    strength: 'train',
    edge: 'recover'
  };

  function buildBullets(answers, topSymptomKey, tier, goal) {
    var pillars = {
      train: pillarTrain(topSymptomKey, tier),
      eat: pillarEat(topSymptomKey, tier),
      recover: pillarRecover(topSymptomKey, tier),
      stack: pillarStack(tier)
    };
    var lead = GOAL_TO_LEAD[goal] || 'train';
    var defaultOrder = ['train', 'eat', 'recover'];
    var order = [lead].concat(defaultOrder.filter(function (p) { return p !== lead; })).concat(['stack']);
    return order.map(function (p) { return pillars[p]; });
  }

  var SYMPTOM_CONTEXT = {
    quiz_energy: 'your daily energy',
    quiz_morning: 'your morning erections',
    quiz_libido: 'your sex drive',
    quiz_motivation: 'your motivation and edge',
    quiz_sleep: 'how you wake up',
    quiz_training: 'your training and body',
    quiz_stress: 'how you handle stress'
  };

  var SYMPTOM_LABELS = {
    quiz_energy: 'Energy',
    quiz_morning: 'Morning erections',
    quiz_libido: 'Drive',
    quiz_motivation: 'Motivation',
    quiz_sleep: 'Recovery',
    quiz_training: 'Training',
    quiz_stress: 'Stress'
  };

  var TIER_CTA = {
    a: 'Unlock My 50% Off For Life',
    b: 'Unlock My 50% Off For Life',
    c: 'Unlock My 50% Off For Life',
    d: 'Unlock My 50% Off For Life'
  };

  var TIER_CONTEXT_PREFIX = {
    a: 'Built for: Strong baseline',
    b: 'Built for: Early-stage T-decline',
    c: 'Built for: Multi-symptom T-decline',
    d: 'Built for: Significant T-decline'
  };

  var TIER_STAGES = {
    a: {
      markers: ['Week 1', 'Month 1', 'Month 3'],
      early: 'Energy and morning sharpness stay locked in. The work is the maintenance.',
      mid: 'Training output and recovery hold. Your baseline does not slip.',
      late: 'You stop noticing this is even a question. Edge feels normal.'
    },
    b: {
      markers: ['Week 2', 'Week 6', 'Week 12'],
      early: 'Morning energy returns. Mid-afternoon crashes start to soften.',
      mid: 'Drive, focus, and training intensity feel closer to where they used to be.',
      late: 'The wear pattern flips. You are back to feeling like yourself.'
    },
    c: {
      markers: ['Week 2', 'Week 8', 'Month 4'],
      early: 'Sleep deepens. Morning grogginess starts to lift.',
      mid: 'Multiple signals shift at once: drive, energy, recovery, mood.',
      late: 'The baseline rebuilds. You stop measuring progress in tired days.'
    },
    d: {
      markers: ['Week 4', 'Month 2', 'Month 4'],
      early: 'First sign of life: deeper sleep, less midday crash.',
      mid: 'The compounding effect kicks in. Multiple signals improve together.',
      late: 'Your body remembers what 100% feels like. The gap closes.'
    }
  };

  function rowTierFromScore(s) {
    if (typeof s !== 'number') return '';
    if (s >= 4) return 'a';
    if (s >= 3) return 'b';
    if (s >= 2) return 'c';
    return 'd';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Quiz_goal answers that have a matching PDP-pain template on the theme.
  // Keep in sync with templates/product.fjor-pain-<goal>.json.
  var PAIN_PDP_GOALS = { energy: 1, drive: 1, strength: 1, edge: 1 };

  function buildPdpUrl(base, answers, score, tier, topSymptomKey, variant) {
    var url = (base || '/products/inner-warrior').split('?')[0];
    var goal = (answers.quiz_goal || '').toLowerCase();
    var params = [
      'quiz=1',
      'score=' + encodeURIComponent(score),
      'tier=' + encodeURIComponent(tier),
      'top_symptom=' + encodeURIComponent(topSymptomKey ? topSymptomKey.replace(/^quiz_/, '') : ''),
      'goal=' + encodeURIComponent(goal),
      'variant=' + encodeURIComponent(variant)
    ];
    // Route to matched pain PDP variant via Shopify's ?view= alternate-template
    // mechanism when the user's quiz_goal maps to a known pillar. Falls through
    // to control PDP if goal is missing or unmapped.
    if (PAIN_PDP_GOALS[goal]) {
      params.push('view=fjor-pain-' + encodeURIComponent(goal));
    }
    return url + '?' + params.join('&');
  }

  function animateScore(el, target) {
    if (!el) return;
    var start = 0;
    var duration = 900;
    var t0 = null;
    var ring = el && el.closest ? el.closest('.fjq-score-ring') : null;
    if (ring) ring.classList.remove('is-revealed');
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / duration);
      var ease = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(start + (target - start) * ease);
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target;
        if (ring) {
          void ring.offsetWidth;
          ring.classList.add('is-revealed');
        }
      }
    }
    requestAnimationFrame(step);
  }

  function buildScoreMap(root) {
    var map = {};
    $$('.fjq-option[data-fjq-key]', root).forEach(function (btn) {
      var key = btn.dataset.fjqKey;
      var val = btn.dataset.fjqValue;
      var score = parseFloat(btn.dataset.fjqScore);
      if (!isNaN(score)) {
        map[key + '::' + val] = score;
      }
    });
    return map;
  }

  function lookupScore(scoreLookup, key, value) {
    var s = scoreLookup[key + '::' + value];
    return typeof s === 'number' ? s : 0;
  }

  function init(root) {
    if (!root || root.dataset.fjqInit === '1') return;
    root.dataset.fjqInit = '1';

    var introVariant = applyIntroVariant(root);

    var productUrl = root.dataset.productUrl || '/products/inner-warrior';
    var override = root.dataset.variantOverride || 'auto';
    var variant = resolveVariant(override);
    root.dataset.fjqVariant = variant;

    // QUIZ-NO-GATE: bypass email capture (gated / soft / inline) until storage is wired.
    root.classList.add('fjq-soft-unlocked');

    var answers = loadAnswers();
    var scoreLookup = buildScoreMap(root);
    var perAnswerScore = {};
    SCORED_KEYS.forEach(function (k) {
      if (answers[k]) perAnswerScore[k] = lookupScore(scoreLookup, k, answers[k]);
    });
    var tierCopy = readTierCopyFromSettings(root);

    var allSteps = $$('[data-fjq-step]', root);
    var flow = allSteps.filter(function (el) {
      var v = el.dataset.fjqVariant;
      if (!v) return true;
      return v === variant;
    });

    var inlineEmailBlock = $('.fjq-inline-email[data-fjq-variant]', root);
    if (inlineEmailBlock) {
      inlineEmailBlock.classList.add('fjq-hidden');
    }

    var softGateBlock = $('[data-fjq-soft-gate]', root);
    var softUnlocked = false;
    try { softUnlocked = sessionStorage.getItem('fjor_quiz_soft_unlocked_v1') === 'true'; } catch (e) {}
    if (variant === 'soft' && softUnlocked) {
      root.classList.add('fjq-soft-unlocked');
    }

    var progressEl = $('.fjq-progress', root);
    var progressFill = $('[data-fjq-progress-fill]', root);
    var progressLabel = $('[data-fjq-progress-label]', root);
    var bulletsEl = $('[data-fjq-bullets]', root);
    var pdpLink = $('[data-fjq-pdp]', root);
    var stickyEl = $('[data-fjq-sticky-cta]', root);
    var stickyLink = $('[data-fjq-sticky-pdp]', root);
    var stickyLabel = $('[data-fjq-sticky-cta-label]', root);
    var stickyObserver = null;

    var questionSteps = flow.filter(function (el) { return el.dataset.fjqId && el.dataset.fjqId.indexOf('q-') === 0; });
    var questionCount = questionSteps.length;

    var current = 0;

    function showStepByIndex(i) {
      current = i;
      flow.forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === i);
      });
      var step = flow[i];
      var id = step ? step.dataset.fjqId : '';
      var qIndex = questionSteps.indexOf(step);
      if (qIndex >= 0 && progressFill && progressLabel) {
        var pct = ((qIndex + 1) / questionCount) * 100;
        progressFill.style.width = pct + '%';
        progressLabel.textContent = 'Step ' + (qIndex + 1) + ' of ' + questionCount;
        progressEl.classList.remove('fjq-hidden');
      } else {
        progressEl.classList.add('fjq-hidden');
      }
      if (id === 'results') {
        renderResults();
      } else {
        teardownStickyObserver();
      }
    }

    function goToId(id) {
      for (var i = 0; i < flow.length; i++) {
        if (flow[i].dataset.fjqId === id) { showStepByIndex(i); return; }
      }
    }

    function goNext() {
      if (current < flow.length - 1) showStepByIndex(current + 1);
    }

    function restoreSelections() {
      $$('[data-fjq-key]', root).forEach(function (btn) {
        if (answers[btn.dataset.fjqKey] === btn.dataset.fjqValue) {
          btn.classList.add('is-selected');
        }
      });
    }

    restoreSelections();
    showStepByIndex(0);

    var startBtn = $('[data-fjq-start]', root);
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        track('QuizStarted', { variant: variant });
        goNext();
      });
    }

    // Mid-quiz break step "Keep going" button. Mirrors startBtn flow.
    $$('[data-fjq-continue]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = flow[current];
        var id = step ? step.dataset.fjqId : '';
        track('QuizBreakContinued', {
          step: id,
          variant: variant,
          intro_variant: root.dataset.quizVariant || null
        });
        goNext();
      });
    });

    // Mid-quiz before/after slider. JS class-toggle to match fjor-before-after-slide
    // pattern from the LP/PDP. Auto-rotates at data-slider-speed ms (default 2400).
    $$('[data-fjq-ba-slider]', root).forEach(function (slider) {
      var slides = $$('.fjq-ba-slide', slider);
      if (slides.length < 2) return;
      var speed = parseInt(slider.getAttribute('data-slider-speed') || '2400', 10);
      if (isNaN(speed) || speed < 800) speed = 2400;
      var idx = 0;
      setInterval(function () {
        slides[idx].classList.remove('active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('active');
      }, speed);
    });

    $$('.fjq-option[data-fjq-key]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.fjqKey;
        var val = btn.dataset.fjqValue;
        answers[key] = val;
        perAnswerScore[key] = lookupScore(scoreLookup, key, val);
        saveAnswers(answers);

        $$('.fjq-option[data-fjq-key="' + key + '"]', root).forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        setTimeout(function () {
          var step = flow[current];
          var id = step ? step.dataset.fjqId : '';
          track('QuizStepCompleted', { step: id, variant: variant });

          if (id === 'q-age') {
            goToId('loader');
            setTimeout(function () {
              goToId('results');
            }, 1500);
          } else {
            goNext();
          }
        }, 240);
      });
    });

    function renderAnswerEcho(topSymptomKey) {
      var echo = $('[data-fjq-answer-echo]', root);
      if (!echo) return;
      if (!topSymptomKey || !answers[topSymptomKey] || !SYMPTOM_CONTEXT[topSymptomKey]) {
        echo.classList.add('fjq-hidden');
        return;
      }
      var answerEl = $('[data-fjq-echo-answer]', root);
      var contextEl = $('[data-fjq-echo-context]', root);
      if (answerEl) answerEl.textContent = answers[topSymptomKey];
      if (contextEl) contextEl.textContent = SYMPTOM_CONTEXT[topSymptomKey];
      echo.classList.remove('fjq-hidden');
    }

    function renderSymptomRecap(scoreMap) {
      var recap = $('[data-fjq-symptom-recap]', root);
      var grid = $('[data-fjq-symptom-grid]', root);
      if (!recap || !grid) return;
      var rows = SCORED_KEYS.map(function (key) {
        var label = SYMPTOM_LABELS[key] || key;
        var answer = answers[key];
        if (!answer) return '';
        var score = typeof scoreMap[key] === 'number' ? scoreMap[key] : null;
        var rowTier = rowTierFromScore(score);
        return '<li class="fjq-symptom-row is-tier-' + rowTier + '">' +
                 '<span class="fjq-symptom-label">' + esc(label) + '</span>' +
                 '<span class="fjq-symptom-value">' + esc(answer) + '</span>' +
                 '<span class="fjq-symptom-dot" aria-hidden="true"></span>' +
               '</li>';
      }).filter(function (s) { return s !== ''; }).join('');
      if (!rows) {
        recap.classList.add('fjq-hidden');
        return;
      }
      grid.innerHTML = rows;
      recap.classList.remove('fjq-hidden');
    }

    function renderStages(tier) {
      var stages = $('[data-fjq-stages]', root);
      if (!stages) return;
      var copy = TIER_STAGES[tier];
      if (!copy) {
        stages.classList.add('fjq-hidden');
        return;
      }
      ['early', 'mid', 'late'].forEach(function (key, i) {
        var marker = $('[data-fjq-stage-marker="' + key + '"]', stages);
        var body = $('[data-fjq-stage-body="' + key + '"]', stages);
        if (marker && copy.markers && copy.markers[i]) marker.textContent = copy.markers[i];
        if (body && copy[key]) body.textContent = copy[key];
      });
      stages.classList.remove('fjq-hidden');
    }

    function renderTierContext(tier, goal) {
      var ctx = $('[data-fjq-tier-context]', root);
      if (!ctx) return;
      var prefix = TIER_CONTEXT_PREFIX[tier];
      if (!prefix) {
        ctx.classList.add('fjq-hidden');
        return;
      }
      var goalSuffix = '';
      if (goal && typeof goal === 'string' && goal.length) {
        goalSuffix = ' · ' + goal.charAt(0).toUpperCase() + goal.slice(1) + ' focus';
      }
      ctx.textContent = prefix + goalSuffix;
      ctx.classList.remove('fjq-hidden');
    }

    function renderCta(tier) {
      var label = $('[data-fjq-cta-label]', root);
      if (label && TIER_CTA[tier]) label.textContent = TIER_CTA[tier];
    }

    function syncStickyCta() {
      if (!stickyLink || !pdpLink) return;
      stickyLink.href = pdpLink.getAttribute('href') || '/products/inner-warrior';
      var mainLabel = $('[data-fjq-cta-label]', pdpLink);
      if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent;
    }

    function teardownStickyObserver() {
      if (stickyObserver) {
        stickyObserver.disconnect();
        stickyObserver = null;
      }
      if (stickyEl) {
        stickyEl.classList.add('fjq-hidden');
        stickyEl.setAttribute('aria-hidden', 'true');
      }
    }

    function setupStickyObserver() {
      teardownStickyObserver();
      if (!stickyEl || !pdpLink || typeof IntersectionObserver === 'undefined') return;
      stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyEl.classList.add('fjq-hidden');
            stickyEl.setAttribute('aria-hidden', 'true');
          } else {
            stickyEl.classList.remove('fjq-hidden');
            stickyEl.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
      stickyObserver.observe(pdpLink);
    }

    function renderResults() {
      var s = computeScore(answers, perAnswerScore);
      var tier = tierFromScore(s.score);
      var copy = tierCopy[tier];

      var ring = $('[data-fjq-score-ring]', root);
      var num = $('[data-fjq-score-number]', root);
      var label = $('[data-fjq-tier-label]', root);
      var headline = $('[data-fjq-tier-headline]', root);
      var message = $('[data-fjq-tier-message]', root);
      var wrap = $('[data-fjq-tier-class]', root);

      if (wrap) {
        wrap.classList.remove('is-tier-a', 'is-tier-b', 'is-tier-c', 'is-tier-d');
        wrap.classList.add('is-tier-' + tier);
      }
      if (ring) ring.style.setProperty('--fjq-score-pct', s.score + '%');
      if (label) label.textContent = copy.label;
      if (headline) headline.textContent = copy.headline;
      if (message) message.textContent = copy.message;

      renderSymptomRecap(perAnswerScore);
      renderAnswerEcho(s.topSymptomKey);
      renderStages(tier);
      renderTierContext(tier, answers.quiz_goal);
      renderCta(tier);

      animateScore(num, s.score);

      var bullets = buildBullets(answers, s.topSymptomKey, tier, answers.quiz_goal);
      if (bulletsEl) {
        bulletsEl.innerHTML = bullets.map(function (t) { return '<li>' + t + '</li>'; }).join('');
      }

      if (pdpLink) {
        pdpLink.href = buildPdpUrl(productUrl, answers, s.score, tier, s.topSymptomKey, variant);
      }

      syncStickyCta();
      setupStickyObserver();

      if (softGateBlock) {
        softGateBlock.classList.add('fjq-hidden');
      }

      track('QuizCompleted', {
        variant: variant,
        intro_variant: root.dataset.quizVariant || null,
        score: s.score,
        tier: tier,
        top_symptom: s.topSymptomKey ? s.topSymptomKey.replace(/^quiz_/, '') : null
      });

      root.dataset.fjqScore = s.score;
      root.dataset.fjqTier = tier;
      root.dataset.fjqTopSymptom = s.topSymptomKey || '';
    }

    // ── Variant A: gate form ─────────────────────────────────────
    var gateForm = $('[data-fjq-gate-form]', root);
    var gateEmail = $('[data-fjq-gate-email]', root);
    var gateError = $('[data-fjq-gate-error]', root);
    var gateOptin = $('[data-fjq-gate-optin]', root);
    var gateSubmitting = false;
    if (gateForm) {
      gateForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (gateSubmitting) return;
        var email = gateEmail && gateEmail.value ? gateEmail.value.trim() : '';
        if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
          if (gateError) gateError.classList.remove('fjq-hidden');
          return;
        }
        if (gateError) gateError.classList.add('fjq-hidden');
        gateSubmitting = true;

        var s = computeScore(answers, perAnswerScore);
        var tier = tierFromScore(s.score);
        var optin = gateOptin ? gateOptin.checked : true;
        var payload = Object.assign({
          quiz_variant: variant,
          quiz_intro_variant: root.dataset.quizVariant || null,
          vitality_score: s.score,
          vitality_tier: tier,
          top_symptom: s.topSymptomKey ? s.topSymptomKey.replace(/^quiz_/, '') : null,
          marketing_optin: optin
        }, answers);

        var sent = pushKlaviyo(email, payload);
        track('QuizEmailSubmitted', { variant: variant, gate: 'gated', klaviyo: sent, optin: optin });
        gateSubmitting = false;
        goToId('results');
      });
    }

    // ── Variant B: inline form on results ────────────────────────
    var inlineForm = $('[data-fjq-inline-form]', root);
    var inlineEmail = $('[data-fjq-inline-email]', root);
    var inlineThanks = $('[data-fjq-inline-thanks]', root);
    var inlineSubmitting = false;
    if (inlineForm) {
      inlineForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (inlineSubmitting) return;
        var email = inlineEmail && inlineEmail.value ? inlineEmail.value.trim() : '';
        if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) return;
        inlineSubmitting = true;

        var s = computeScore(answers, perAnswerScore);
        var tier = tierFromScore(s.score);
        var payload = Object.assign({
          quiz_variant: variant,
          quiz_intro_variant: root.dataset.quizVariant || null,
          vitality_score: s.score,
          vitality_tier: tier,
          top_symptom: s.topSymptomKey ? s.topSymptomKey.replace(/^quiz_/, '') : null
        }, answers);

        var sent = pushKlaviyo(email, payload);
        track('QuizEmailSubmitted', { variant: variant, gate: 'open', klaviyo: sent });

        if (inlineThanks) inlineThanks.classList.remove('fjq-hidden');
        if (inlineEmail) inlineEmail.value = '';
        inlineSubmitting = false;
      });
    }

    // ── Variant C: soft-gate form ────────────────────────────────
    var softForm = $('[data-fjq-soft-form]', root);
    var softEmailInput = $('[data-fjq-soft-email]', root);
    var softError = $('[data-fjq-soft-error]', root);
    var softOptin = $('[data-fjq-soft-optin]', root);
    var softSubmitting = false;
    if (softForm) {
      softForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (softSubmitting) return;
        var email = softEmailInput && softEmailInput.value ? softEmailInput.value.trim() : '';
        if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
          if (softError) softError.classList.remove('fjq-hidden');
          return;
        }
        if (softError) softError.classList.add('fjq-hidden');
        softSubmitting = true;

        var s = computeScore(answers, perAnswerScore);
        var tier = tierFromScore(s.score);
        var optin = softOptin ? softOptin.checked : true;
        var payload = Object.assign({
          quiz_variant: variant,
          quiz_intro_variant: root.dataset.quizVariant || null,
          vitality_score: s.score,
          vitality_tier: tier,
          top_symptom: s.topSymptomKey ? s.topSymptomKey.replace(/^quiz_/, '') : null,
          marketing_optin: optin
        }, answers);

        var sent = pushKlaviyo(email, payload);
        track('QuizEmailSubmitted', { variant: variant, gate: 'soft', klaviyo: sent, optin: optin });

        root.classList.add('fjq-soft-unlocked');
        if (softGateBlock) softGateBlock.classList.add('fjq-hidden');
        try { sessionStorage.setItem('fjor_quiz_soft_unlocked_v1', 'true'); } catch (e2) {}

        softSubmitting = false;
      });
    }

    if (pdpLink) {
      pdpLink.addEventListener('click', function () {
        track('QuizCTAClicked', {
          variant: variant,
          intro_variant: root.dataset.quizVariant || null,
          score: parseInt(root.dataset.fjqScore || '0', 10),
          tier: root.dataset.fjqTier || '',
          top_symptom: root.dataset.fjqTopSymptom ? root.dataset.fjqTopSymptom.replace(/^quiz_/, '') : null,
          source: 'primary'
        });
      });
    }

    if (stickyLink) {
      stickyLink.addEventListener('click', function () {
        track('QuizCTAClicked', {
          variant: variant,
          intro_variant: root.dataset.quizVariant || null,
          score: parseInt(root.dataset.fjqScore || '0', 10),
          tier: root.dataset.fjqTier || '',
          top_symptom: root.dataset.fjqTopSymptom ? root.dataset.fjqTopSymptom.replace(/^quiz_/, '') : null,
          source: 'sticky'
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      $$('[data-fjor-quiz]').forEach(init);
    });
  } else {
    $$('[data-fjor-quiz]').forEach(init);
  }
})();
// Build: 1779973869-r11-softgate
